const MODEL_BUILD_STATUS = {
  BUILDING: "building",
  GENERATED: "generated",
  NOT_GENERATED: "notGenerated",
};

export default MODEL_BUILD_STATUS;
